import { render, staticRenderFns } from "./HeaderNewChatButton.vue?vue&type=template&id=411cc4f2"
import script from "./HeaderNewChatButton.vue?vue&type=script&lang=js"
export * from "./HeaderNewChatButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderNewChatButton.vue?vue&type=style&index=0&id=411cc4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports